import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { RestService } from '../../service/rest.service';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'std-select',
  templateUrl: './select.component.html',
  styles: [],
  standalone: false,
})
export class SelectComponent implements OnInit {
  constructor(private elementRef: ElementRef, private rest: RestService, private loader: LoaderService) { }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    const nativeElement: any = this.elementRef.nativeElement;
    const clickedInside: boolean = nativeElement.contains(event.target);
    if (!clickedInside) {
      this.expanded = false;
      this.internalPageScroll = 0;
      this.limitBefore = this.internalPageScroll * 5;
      this.limitAfter = this.elementsToDisplay + 5 * this.internalPageScroll;
      if (this.limitBefore < 0) {
        this.limitBefore = 0;
      }
      if (this.limitAfter > this.data?.length) {
        this.limitAfter = this.data?.length;
      }
      this.clickOutside.emit();
    }
  }
  @Input() data: any = [];
  @Input() bindLabel: string = 'label';
  @Input() bindValue: string = 'value';
  @Input() placeholder: string = 'Placeholder';
  @Input() label!: string;
  @Input()elementPage = false
  @Input() labelPosition: 'left' | 'top' | 'right' | 'bottom' = 'left';
  @Input() customLabel: string = '';
  @Input() labelElementSelected: string = ' Elementi selezionati';
  @Input() labelOneElementSelected: string = ' Elemento selezionato';
  @Input() customClassContaier: string = '';
  @Input() customClassSubContaier: string = '';
  @Input() customClassContainerElement: string = '';
  @Input() customClassClose: string = '';
  @Input() customPillClass: string = '';
  @Input() direction: 'up' | 'down' = 'down';
  @Input() multiple: boolean = false;
  @Input() showMultipleSelection = true;
  @Input() showNumberSelected = false;
  @Input() currentValue: any = null;
  @Input() closeOnSelection: boolean = true;
  @Input() iconClose: string = '';
  @Input() showCheck = true;
  @Input() filterable: boolean = false;
  @Input() filterSearch: string = '';
  @Input() filterLabel: string = 'Cerca';
  @Input() searchInLowerCase: boolean = false;
  @Input() typeOfFiltrableSelect: 'includes' | 'startsWith' = 'includes';
  @Input() pipeTranslationLabelSelect: any;
  @Input() elementsToDisplay = 20;
  @Input() useDataInfiniteScroll = true;
  @Input() id = Math.floor(Math.random() * 10000000) + 1;
  @Input() endpointData = ''
  @Output()
  onChangeValue: EventEmitter<void> = new EventEmitter();
  @Output() clickOutside: EventEmitter<void> = new EventEmitter();
  @Output() filterKeyDown: EventEmitter<any> = new EventEmitter();
  ready = false
  internalPageScroll = 0;
  limitBefore = 0;
  limitAfter = this.elementsToDisplay;
  expanded: boolean = false;
  originalData: any
  currentPagesSelect = 1

  ngOnInit(): void {
    if (this.data?.totalPages || this.data?.totalPages == 0) {
      this.originalData = JSON.parse(JSON.stringify(this.data))
      this.data = this.data.data
      this.ready = true
    } else {
      this.ready = true
    }
  }

  addElement(item: any) {
    if (this.closeOnSelection) {
      this.expanded = false;
    }
    if (this.multiple) {
      if (!this.currentValue) {
        this.currentValue = [item];
      } else {
        const indexElement = this.currentValue.findIndex(
          (element: any) => element[this.bindValue] == item[this.bindValue]
        );

        if (indexElement !== -1) {
          this.currentValue.splice(indexElement, 1);
        } else {
          this.currentValue.push(item);
        }
      }

      this.onChangeValue.emit(this.currentValue);
    } else {
      this.currentValue = item;
      this.onChangeValue.emit(this.currentValue);
    }
  }

  scrollData(scrollEvent: any) {

    if (
      scrollEvent.target.scrollTop + scrollEvent.target.scrollWidth >
      scrollEvent.target.scrollHeight &&
      this.limitAfter != this.data?.length
    ) {
      this.internalPageScroll = this.internalPageScroll + 1;
      this.limitBefore = this.internalPageScroll * 5;
      this.limitAfter = this.elementsToDisplay + 5 * this.internalPageScroll;
      if (this.limitBefore < 0) {
        this.limitBefore = 0;
      }
      if (this.limitAfter > this.data?.length) {
        this.limitAfter = this.data?.length;
      }

      scrollEvent.target.scrollTop = scrollEvent.target.scrollTop - 100;
    }
    if (scrollEvent.target.scrollTop == 0 && this.internalPageScroll > 0) {
      this.internalPageScroll = this.internalPageScroll - 1;
      this.limitBefore = this.internalPageScroll * 5;
      this.limitAfter = this.elementsToDisplay + 5 * this.internalPageScroll;
      if (this.limitBefore < 0) {
        this.limitBefore = 0;
      }
      if (this.limitAfter > this.data?.length) {
        this.limitAfter = this.data?.length;
      }

      scrollEvent.target.scrollTop = 100;
    }

    if (this.endpointData && this.currentPagesSelect < this.originalData?.totalPages && scrollEvent.target.scrollTop == (scrollEvent.target.scrollHeight - scrollEvent.target.offsetHeight)) {
      this.loader.on()
      this.currentPagesSelect = this.currentPagesSelect + 1
      let params = {"page":this.currentPagesSelect,"filters":[]}
      this.rest.get(this.endpointData + '?options=' + JSON.stringify(params)).subscribe({
        next:(value:any)=> {
          this.data = [...this.data, ...value.data]
          this.loader.off(true)
          setTimeout(() => {
                 scrollEvent.target.scrollTop = 100;
          }, 0);
        },
       error:(error:any)=> {
        this.currentPagesSelect = this.currentPagesSelect - 1
          this.loader.off(true)
        },
      })
    }
  }

  log(log: any) {
  }

  addFocus() {
    let myInput = document.getElementById('select-filter-input-' + this.id)
    if (myInput && this.expanded) {
      myInput.focus()
    }
  }

  removeFocus() {
    let myInput = document.getElementById('select-filter-input-' + this.id)
    if (myInput && this.expanded) {
      myInput.blur()
    }
  }

  changeStatusSelect(event: any) {
    setTimeout(() => {
      this.expanded = !this.expanded
      this.focusInput(event)
    }, 0);

  }

  removeItem(index: number) {
    this.currentValue.splice(index, 1);
    this.onChangeValue.emit(this.currentValue);
  }

  filterSearchKey($event: any) {
    this.internalPageScroll = 0;
    this.limitBefore = this.internalPageScroll * 5;
    this.limitAfter = this.elementsToDisplay + 5 * this.internalPageScroll;
    if (this.limitBefore < 0) {
      this.limitBefore = 0;
    }
    if (this.limitAfter > this.data?.length) {
      this.limitAfter = this.data?.length;
    }

    setTimeout(() => {
      this.filterKeyDown.emit({ event: $event, value: this.filterSearch });
    }, 0);
  }

  getFilteredData() {
    if (this.data) {
      let dataToFilter = JSON.parse(JSON.stringify(this.data));
      switch (this.typeOfFiltrableSelect) {
        case 'includes':
          return dataToFilter.filter((myItem: any) => {
            if (myItem[this.bindLabel]) {
              return myItem[this.bindLabel]
                .toLowerCase()
                .includes(this.filterSearch.toLowerCase());
            } else {
              return false;
            }
          });
        case 'startsWith':
          return dataToFilter.filter((myItem: any) => {
            if (myItem[this.bindLabel]) {
              return myItem[this.bindLabel]
                .toLowerCase()
                .startsWith(this.filterSearch.toLowerCase());
            } else {
              return false;
            }
          });
        default:
          return dataToFilter.filter((myItem: any) => {
            if (myItem[this.bindLabel]) {
              return myItem[this.bindLabel]
                .toLowerCase()
                .includes(this.filterSearch.toLowerCase());
            } else {
              return false;
            }
          });
      }
    } else {
      return []
    }
  }

  focusInput(event: Event) {
    const target = event.target as HTMLElement | null;
    if (this.expanded && this.filterable && target) {
      setTimeout(() => {
        const firstInput = target.querySelector('input');
        if (firstInput) {
          firstInput.focus();
        }
      }, 0);
    }
  }

  controlCheck(value: any) {
    if (this.currentValue) {
      let isChecked = this.currentValue.findIndex(
        (res: any) => res[this.bindValue] === value
      );
      return isChecked === -1 ? false : true;
    } else {
      return false;
    }
  }
}
